module.exports = __webpack_public_path__ + "static/media/icon-link.242eda5d.svg";